import { render } from "./MasterDataUserUnitKerjaForm.vue?vue&type=template&id=9bf4a2c0"
import script from "./MasterDataUserUnitKerjaForm.vue?vue&type=script&lang=js"
export * from "./MasterDataUserUnitKerjaForm.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__